import { Spinner, Stack, Text } from "@chakra-ui/react";
import { ReactNode, Suspense } from "react";
import { Await, useLoaderData } from "react-router-dom";
import { AuthResponse } from "types";
import ErrorBoundary from "./ErrorBoundary";

export default function Page({ component }: { component: ReactNode }) {
  const { user } = useLoaderData() as { user: AuthResponse };

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <Await resolve={user}>{() => component}</Await>
      </Suspense>
    </ErrorBoundary>
  );
}

function Loading() {
  return (
    <Stack
      height={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={8}
    >
      <Spinner size={"xl"} />
      <Text size={"xl"}>{process.env.REACT_APP_NAME}</Text>
    </Stack>
  );
}
